import { OrganisationConnection } from "@/types/organisatio";
import { Customer } from "../types";
import { OrganisationWithLicencesResponse } from "@/types/licenceSolutions";
import { ALL_SERVICES } from "@/utils/services.ts";

type SolutionItem = {
  solution_uuid: string;
  solution_name: string;
  uuid: string;
};

export const transformOrganisationsToCustomers = (
  organisations: OrganisationWithLicencesResponse[],
  connections: OrganisationConnection[],
): Customer[] => {
  const connectionsDictionary = connections.reduce(
    (acc: Record<string, OrganisationConnection>, cur) => {
      acc[cur.organisation_uuid] = cur;
      return acc;
    },
    {},
  );

  return organisations.map((organisation) => {
    return {
      uuid: organisation.uuid,
      name: organisation.name,
      description: organisation.description ?? "",
      organisation_type: organisation.organisation_type || "",
      seats_used: organisation.licence?.seats_used || 0,
      seats_purchased: organisation.licence?.seats_purchased || 0,
      created_at: organisation.created_at,
      solutions: ALL_SERVICES.map((service) => {
        const solutions = organisation.licence?.solutions;
        let isServiceEnabled = false;

        if (solutions?.length) {
          // Check if first element is array (nested structure)
          if (Array.isArray(solutions[0])) {
            isServiceEnabled = solutions[0].some(
              (availableService: SolutionItem) =>
                availableService.solution_uuid === service.uuid,
            );
          }
          // First element is object (flat structure)
          else {
            isServiceEnabled = (solutions as unknown as SolutionItem[]).some(
              (availableService: SolutionItem) =>
                availableService.solution_uuid === service.uuid,
            );
          }
        }

        return {
          ...service,
          isServiceEnabled,
        };
      }),
      hasConnection: connectionsDictionary[organisation.uuid]?.connected,
      isLegacy: connectionsDictionary[organisation.uuid]?.legacy ?? false,
      auth0_migration_version: organisation.auth0_migration_version,
    };
  });
};
